import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";

export const getReports = ({
  order_no = "",
  order_no__gt = "",
  order_no__lt = "",
  grant_total = "",
  grant_total__gt = "",
  grant_total__lt = "",
  payment = "",
  customer = "",
  machine = "",
  vend_status = "",
  qty = "",
  qty__gt = "",
  qty__lt = "",
  product = "",
  category = "",
  hsn = "",
  sub_category = "",
  date_after = "",
  date_before = "",
  date_iso_after = "",
  date_iso_before = "",
  location= "",
  order = "",
  page = 1,
}) => {
  return server_api.get(
    `/sales/order/get_detailed?order_no=${order_no}&order_no__gt=${order_no__gt}&order_no__lt=${order_no__lt}&grant_total=${grant_total}&grant_total__gt=${grant_total__gt}&grant_total__lt=${grant_total__lt}&payment=${payment}&customer=${customer}&vend_status=${vend_status}&qty=${qty}&qty__gt=${qty__gt}&qty__lt=${qty__lt}&product=${product}&machine=${machine}&hsn=${hsn}&category=${category}&sub_category=${sub_category}&date_after=${date_after}&date_before=${date_before}&date_iso_after=${date_iso_after}&date_iso_before=${date_iso_before}&location=${location}&o=${order}&page=${page}`
  );
};

export const getTotalForReports = (filter) => {
  return server_api.get(
    `/sales/order/get_total?order_no=${filter?.order_no ?? ""}&order_no__gt=${
      filter?.order_no__gt ?? ""
    }&order_no__lt=${filter?.order_no__lt ?? ""}&grant_total=${
      filter?.grant_total ?? ""
    }&grant_total__gt=${filter?.grant_total__gt ?? ""}&grant_total__lt=${
      filter?.grant_total__lt ?? ""
    }&payment=${filter?.payment ?? ""}&customer=${
      filter?.customer ?? ""
    }&vend_status=${filter?.vend_status ?? ""}&qty=${
      filter?.qty ?? ""
    }&qty__gt=${filter?.qty__gt ?? ""}&qty__lt=${
      filter?.qty__lt ?? ""
    }&product=${filter?.product ?? ""}&hsn=${filter?.hsn ?? ""}&category=${
      filter?.category ?? ""
    }&sub_category=${filter?.sub_category ?? ""}&date_after=${
      filter?.date_after ?? ""
    }&date_before=${filter?.date_before ?? ""}&date_iso_after=${
      filter?.date_iso_after ?? ""
    }&date_iso_before=${filter?.date_iso_before ?? ""}&o=${
      filter?.order ?? ""
    }&location=${filter?.location ?? ""}&machine=${filter?.machine ?? ""}`
  );
};

export const getInvoiceFromUuid = (uuid) => {
  return server_api.get(`/sales/order/get-from-uuid?uuid=${uuid}`);
};

export const getInvoiceConfiguration = () => {
  return server_api.get("/sales/invoice-configuration");
};

export const postInvoiceConfiguration = (data) => {
  return server_api.postForm("/sales/invoice-configuration", toFormData(data));
};

export const initiateRefund = (id, data) => {
  return server_api.postForm(`/sales/order/${id}/initiate_refund`, toFormData(data));
}
